'use client';

export const Close = ({ className, ...props }: React.ComponentPropsWithoutRef<'svg'>) => {
	return (
		<svg
			width="32"
			height="32"
			viewBox="0 0 32 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			{...props}
		>
			<path
				d="M16 17.4001L7.70169 25.6988C7.51094 25.8896 7.28009 25.9875 7.00914 25.9925C6.73819 25.9975 6.5022 25.8996 6.30116 25.6988C6.10039 25.4978 6 25.2643 6 24.9984C6 24.7327 6.10039 24.4993 6.30116 24.2983L14.5999 16L6.30116 7.70169C6.11041 7.51094 6.01253 7.28009 6.00752 7.00914C6.00251 6.73819 6.10039 6.5022 6.30116 6.30116C6.5022 6.10039 6.73568 6 7.00162 6C7.2673 6 7.50065 6.10039 7.70169 6.30116L16 14.5999L24.2983 6.30116C24.4891 6.11041 24.7199 6.01253 24.9909 6.00752C25.2618 6.00251 25.4978 6.10039 25.6988 6.30116C25.8996 6.5022 26 6.73568 26 7.00162C26 7.2673 25.8996 7.50065 25.6988 7.70169L17.4001 16L25.6988 24.2983C25.8896 24.4891 25.9875 24.7199 25.9925 24.9909C25.9975 25.2618 25.8996 25.4978 25.6988 25.6988C25.4978 25.8996 25.2643 26 24.9984 26C24.7327 26 24.4993 25.8996 24.2983 25.6988L16 17.4001Z"
				fill="currentColor"
			/>
		</svg>
	);
};
